import mixitup from 'mixitup';
import mixitupMultifilter from '../vendor/mixitup-multifilter.min';

mixitup.use(mixitupMultifilter);

jQuery(document).ready(function($){

    // Project items filter
    if ($(".projects-container")[0]){
        var mixer = mixitup('.projects-container', {
            multifilter: {
                enable: true // enable the multifilter extension for the mixer
            },
            animation: {
            duration: 500,
            effectsIn: 'fade translateY(20px)',
            effectsOut: 'fade translateY(-20px)',
            easing: 'cubic-bezier(0.86, 0, 0.07, 1)',
            reverseOut: false
            }
        });
    }
});
